import { B2BTeamMember } from '../../modules/b2b/team/types';

export const MOCK_FACE_API_TEAM_RESPONSE: { members: B2BTeamMember[] } = {
  members: [
    {
      id: 'agent-101',
      fullName: 'Александр Волков',
      email: 'a.volkov@travel-pro.ru',
      phone: '+7 916 452-18-31',
      role: 'administrator',
      status: 'active',
      lastSeen: 'Сегодня, 12:41',
      createdAt: '12 сентября 2025',
    },
    {
      id: 'agent-102',
      fullName: 'Елена Морозова',
      email: 'e.morozova@travel-pro.ru',
      phone: '+7 903 817-44-05',
      role: 'agent',
      status: 'active',
      lastSeen: 'Сегодня, 11:18',
      createdAt: '3 февраля 2026',
    },
    {
      id: 'agent-103',
      fullName: 'Ирина Соколова',
      email: 'i.sokolova@travel-pro.ru',
      phone: '+7 925 201-73-62',
      role: 'agent',
      status: 'invited',
      lastSeen: 'Приглашение отправлено',
      createdAt: '26 сентября 2026',
    },
    {
      id: 'agent-104',
      fullName: 'Дмитрий Крылов',
      email: 'd.krylov@travel-pro.ru',
      phone: '+7 985 620-11-09',
      role: 'agent',
      status: 'disabled',
      lastSeen: '18 сентября, 17:02',
      createdAt: '20 ноября 2025',
    },
  ],
};
